<template>
  <div class="guidesDocContent">
    <div v-if="docInfo.docName"
         class="container"
         :class="{apiContainer:docInfo.docType==='API',videoContainer:docInfo.docType==='VIDEO',pdfContainer:docInfo.docType==='PDF'}">
      <div class="mdfile scroll" ref="elscrollbar" :class="{mdfile_stack:this.$root.$data.wiseStack}">
        <article class="mdfilebox" id="mdfilebox" :class="{sidemenuClose:!sideMenuOpen}">
          <h1 class="mdfileTitle">{{docInfo.docTitle}}</h1>
          <div class="mdfileInfoLine">
            <time class="timeInfo">{{docInfo.time | moment('MMMM DD, YYYY')}}</time>
            <div class="versionInfo" v-if="(!isChinaDomain()) || (isChinaDomain() && checkUrlVersion())">
              <el-select v-model="docInfo.version" @change="getVersion">
                <el-option
                  v-for="item in options"
                  :key="item.version"
                  :label="item.version"
                  :value="item.version"
                ></el-option>
              </el-select>
            </div>
          </div>
          <!-- <div><el-button @click="downloadMarkdownPDF">Download PDF</el-button></div> -->  <!-- hide this button 20220106 by Dolly -->
          <mavon-editor
            v-if="docInfo.docType==='M.D.' || docInfo.docType==='VIDEO'"
            ref="mavonblock"
            class="mavon"
            language="en"
            defaultOpen="preview"
            boxShadowStyle="none"
            previewBackground="#fff"
            :subfield = false
            :toolbarsFlag = false
            v-model="docInfo.content"></mavon-editor>
          <div class="videoFrame" v-if="docInfo.docType==='VIDEO'">
            <el-tabs type="card" v-model="activeVideoSource">
              <el-tab-pane
                :label="'Source '+ (index + 1) +' ('+ item.local +')'"
                :name="index.toString()"
                v-for="(item, index) in videoInfo.sources" :key="index">
                <iframe v-if="item.type === 'iframe'" :src="item.link" async allowfullscreen></iframe>
                <object v-if="item.type === 'embed'">
                  <embed
                    :src="item.link" width="100%" height="100%" align="middle"
                    allowScriptAccess="always" allowFullscreen="true" type="application/x-shockwave-flash" />
                </object>
              </el-tab-pane>
            </el-tabs>
          </div>
          <div class="videoRef" v-if="docInfo.docType==='VIDEO' && videoInfo.refs.length>0">
            <p style="font-weight: bold; font-family: 'Roboto Bold', 'Microsoft JhengHei'; font-size: 16px; margin-bottom:16px;color: #787878;line-height: 24px;">{{$t("Reference")}}</p>
            <ul>
              <li v-for="(item,index) in videoInfo.refs" :key="index">
                <a :href="item.link" target="_blank" v-if="item.link">
                  <p class="tp-link">{{item.title}}
                    <i style="vertical-align: top;" class="tp-icon-extra-small"
                       :class="{'tp-icon-link':item.link_type == 'LINK','tp-icon-file':item.link_type == 'FILE'}"></i>
                  </p>
                </a>
                <p v-if="!item.link">{{item.title}}</p>
              </li>
            </ul>
          </div>
          <div id="swagger-ui" v-if="docInfo.docType==='API'"></div>
          <div v-if="docInfo.docType==='PDF' && pdfPage>0" style="border: 1px solid #e6e6e6;margin-bottom: 30px;">
            <pdf
              v-for="i in pdfLoadedPage" :key="i" :src="pdfSrc" :page="i"
              style="display: inline-block; width: 100%;"></pdf>
            <div v-if="pdfLoadedPage<pdfPage" class="pdf-load-more" @click="loadMorePDF">
              <span>View More Pages</span>
            </div>
          </div>
          <div v-if="!this.$root.$data.wiseStack">
            <child-component ref="feedbackPopup" :log_id="docInfo.log_id" :version="docInfo.version"></child-component>
          </div>
          <div class="feedbackBlock" id="feedbackBlock" v-if="!this.$root.$data.wiseStack">
            <feedback-bottom :forumId="docInfo.forumId"></feedback-bottom>
          </div>
        </article>
      </div>
      <aside class="mdMenu scroll" :class="{mdMenu_stack:this.$root.$data.wiseStack}">
        <div class="rightMenu scroll">
          <div class="menuTitle">{{$t('On_this_page')}}</div>
          <ul class="menuItem">
            <li v-for="(item, index) in outlineList" :key="index">
              <span class="listIcon"></span>
              <span class="listItem" @click="clickMenu(item.id)">
                <div class="menu-item">{{item.innerHTML}}</div>
              </span>
            </li>
          </ul>
        </div>
      </aside>
    </div>
  </div>
</template>

<script>
import frontAPI from '@/api/frontstage/frontAPI'
import feedbackPopup from '../Feedback/FeedbackPopup'
import feedbackBottom from '@/components/Feedback/FeedbackBottom.vue'
import swaggerUI from 'swagger-ui'
import 'swagger-ui/dist/swagger-ui.css'
import { mavonEditor } from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
import pdf from 'vue-pdf'
// import html2Canvas from 'html2canvas'
// import { jsPDF } from "jspdf";

// const htmlToPdf = {
//     getPdf(title) {
//         html2Canvas(document.querySelector('#mdfilebox'), {
//             dpi: 300,
//             scale: 2
//         }).then(canvas=>{
//             let contentWidth = canvas.width;
//             let contentHeight = canvas.height;
//             let pageHeight = contentWidth / 592.28 * 841.89;
//             let leftHeight = contentHeight;
//             let position = 0;
//             let imgWidth = 595.28;
//             let imgHeight = 592.28 / contentWidth * contentHeight;
//             let pageData = canvas.toDataURL('image/jpeg', 1.0);
//             let PDF = new jsPDF('', 'pt', 'a4');
//             if (leftHeight < pageHeight) {
//                 PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
//             } else {
//                 while (leftHeight > 0) {
//                     PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight);
//                     leftHeight -= pageHeight;
//                     position -= 841.89;
//                     if (leftHeight > 0) {
//                         PDF.addPage()
//                     }
//                 }
//             }
//             PDF.save(title + '.pdf')
//         })
//     }
// };

export default {
  name: 'guidesDocContent',
  components: {
    pdf,
    'child-component': feedbackPopup,
    feedbackBottom,
    mavonEditor
  },
  props: {
    docInfo: {
      id: Number,
      lang: Number,
      log_id: Number,
      time: String,
      link: String,
      version: String,
      content: String,
      docName: String,
      docTitle: String,
      forumId: String,
      docType: String,
      sideMenuOpen: Boolean
    },
    videoInfo: {
      sources: Array,
      refs: Array
    }
  },
  data () {
    return {
      dataContent: '',
      outlineList: [],
      options: [],
      sideMenuOpen: true,
      activeVideoSource: '0',
      pdfSrc: null,
      pdfPage: 0,
      pdfLoadedPage: 0
    }
  },
  mounted () {
    if (this.docInfo.docType === 'API') {
      this.swaggerUI = swaggerUI({
        dom_id: '#swagger-ui'
      })
      if (!this.docInfo.content) {
        this.docInfo.content = ' '
      }
      this.swaggerUI.specActions.updateSpec(this.docInfo.content)
    }
  },
  created () {
    this.renderVersionList()
    this.sideMenuOpen = this.docInfo.sideMenuOpen
    if (this.docInfo.docType === 'PDF') {
      this.initPDF(this.docInfo.link)
    }
    // 跳轉至此頁面時強制頁面 offset 先行歸零
    window.scrollTo(0, 0)
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    renderVersionList () {
      frontAPI
        .queryVersion('?doc_id=' + this.docInfo.id)
        .then(resp => {
          this.options = resp.data.data
          this.options = this.options.sort(function (a, b) {
            return a.version < b.version ? 1 : -1
          })
        })
        .catch(err => {
          console.log('queryVersion error---', err)
        })
        .then(() => {
          if (this.docInfo.docType === 'M.D.') {
            this.parseHTML()
          }
          if(this.docInfo.version != this.options[0].version) {
            // this.getVersion(this.options[0].version)
            this.getVersion(this.docInfo.version)
          }
        })
    },
    parseHTML () {
      let outlineElement = this.$refs.mavonblock.$refs.vShowContent.getElementsByTagName('h1')
      this.outlineList = []
      for (let i = 0; i < outlineElement.length; i++) {
        this.outlineList.push({
          id: outlineElement[i].firstChild.id,
          innerHTML: outlineElement[i].textContent
        })
      }
    },
    handleScroll () {
      if (this.outlineList && this.outlineList.length > 0) {
        for (let i = this.outlineList.length - 1; i >= 0; i--) {
          if (window.pageYOffset >= document.getElementById(this.outlineList[i]['id']).offsetTop) {
            for (let j = 0; j < document.getElementsByClassName('menuItem')[0].childNodes.length; j++) {
              document
                .getElementsByClassName('menuItem')[0]
                .childNodes[j].classList.remove('activeItem')
            }
            document.getElementsByClassName('menuItem')[0].childNodes[i].classList.add('activeItem')
            break
          }
        }
      }
    },
    clickMenu (el) {
      let target = document.getElementById(el)
      let titleHeight = document.getElementsByClassName('mdfileTitle')[0].scrollHeight
      window.scrollTo({ top: target.offsetTop + titleHeight + 60, behavior: 'smooth' })
    },
    getVersion (ver) {
      this.$router.replace({ params: { ver: ver.trim() } })
    },
    initPDF (url) {
      let that = this
      this.pdfSrc = pdf.createLoadingTask(window.location.origin + url)
      this.pdfSrc.then(pdf => {
        that.pdfPage = pdf.numPages
        let loadedPage = that.pdfLoadedPage + 5
        that.pdfLoadedPage = (loadedPage > pdf.numPages) ? pdf.numPages : loadedPage
      })
    },
    loadMorePDF () {
      if (this.pdfLoadedPage < this.pdfPage) {
        let loadedPage = this.pdfLoadedPage + 5
        this.pdfLoadedPage = (loadedPage > this.pdfPage) ? this.pdfPage : loadedPage
      }
    },
    isChinaDomain () {
      return window.location.hostname === this.$store.state.hostNameVals.chainHostName
    },
    checkUrlVersion (){
      var url = window.location.pathname.split( '/' )
      var urlVerPath = url[ url.length - 1 ]
        if(urlVerPath.indexOf('v') === 0) {
          return true
        } else {
          return false
        }
    },
    downloadMarkdownPDF (){
      const titlename =  document.querySelector('#mdfilebox').getElementsByTagName('h1')[0].innerText
      htmlToPdf.getPdf(titlename);
    }
  }
}
</script>
<style lang="scss">
.no-header {
  .guidesDoc {
    .mainContent{
      .guidesDocContent .container {
        .mdMenu {
          max-height: calc(100vh - 106px);
        }
      }
      @media (max-width: 950px) {
        .guidesDocContent .container {
          .mdMenu {
            max-height: calc(100vh - 98px);
          }
        }
      }
    }
  }
  &.no-footer {
    .guidesDoc {
      .mainContent{
        .guidesDocContent .container {
          .mdMenu {
            max-height: calc(100vh - 56px);
          }
        }
        @media (max-width: 950px) {
          .guidesDocContent .container {
            .mdMenu {
              max-height: calc(100vh - 48px) !important;
            }
          }
        }
      }
    }
  }
}
.guidesDocContent .container {
  .mdMenu, .mdfile {
    overflow-x: hidden;
    .v-show-content {
      padding: 0 !important;
    }
    .v-note-wrapper {
      min-height: initial;
      min-width: 250px;
      z-index: auto;
    }
  }
}

.mdfilebox {
  h1 {
    font-size: 28px;
  }
  h2 {
    font-size: 24px;
  }
  h3 {
    font-size: 20px;
  }
  h4 {
    font-size: 18px;
  }
  h5, p {
    font-size: 16px;
  }
}
.swagger-ui{
  line-height: initial;
  .model {
    font-weight: normal;
  }
}
.videoFrame{
  .el-tabs__header{
    margin: 0 0 10px;
    position: relative;
    top: 0;
    z-index: 3;
    .el-tabs__nav{
      border: none;
    }
    .el-tabs__nav-wrap{
      padding-left: 0;
      background: none;
      border-bottom: solid 1px #3970e6;
      .el-tabs__item{
        background-color: #f5f5f5;
        padding: 0 16px !important;
        height: 32px;
        line-height: 32px;
        font-size: 14px;
        color: #787878;
        border-bottom: none;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        &:hover{
          background-color: #f1f6ff;
        }
      }
      .el-tabs__item.is-active {
        color: #fff;
        background-color: #3970e6;
        font-weight: normal;
        font-family: "Roboto Regular", "Microsoft JhengHei";
        border-bottom: none;
      }
    }
  }
}
i.tp-icon-extra-small{
  display: inline-block;
  margin-top: auto;
  margin-bottom: auto;
  line-height: 24px;
  width: 24px;
  height: 24px;
  background-size: 24px;
}
.tp-icon-link {
  background-image: url("../../assets/icon/btn_main_link_normal.svg");
  &:hover, &:active {
    background-image: url("../../assets/icon/btn_main_link_normal.svg");
  }
}
.tp-icon-file {
  background-image: url("../../assets/icon/img_file.svg");
  &:hover, &:active {
    background-image: url("../../assets/icon/img_file.svg");
  }
}

</style>

<style lang="scss" scoped>
.el-scrollbar__thumb {
  height: 20%;
}
.el-scrollbar {
  height: 100%;
  border-bottom: 2px solid #008cd6;
  overflow: hidden;
  position: relative;
  display: block;
  .el-scrollbar__wrap {
    overflow: scroll;
    height: 100%;
    margin-bottom: -30px;
    margin-right: -30px;
    max-height: 200px;
    display: block;
  }
  .is-horizontal {
    display: none;
  }
}

.guidesDocContent {
  position: relative;
  margin: 0;
  scroll-behavior: smooth;
  .container {
    position: relative;
    display: flex;
    .mdfile {
      width: 100%;
      flex: 1;
      -ms-flex-preferred-size:auto;
      flex-basis:auto;
      background: #ffffff;
      .mdfilebox {
        padding-left: 24px;
        box-sizing: border-box;
        width: calc(100vw - 582px);
        position: relative;
        flex: 1;
        margin-top: 20px;
        padding-right: 17px;
        .mdfileTitle {
          line-height: 40px;
          font-size: 30px;
          font-weight: bold;
          font-family: "Roboto Bold", "Microsoft JhengHei";
          color: #004280;
        }
        .mdfileInfoLine {
          margin-top: 10px;
          margin-bottom: 16px;
          height: 32px;
          display: flex;
          justify-content: space-between;
          .timeInfo {
            line-height: 32px;
            font-size: 16px;
            color: #787878;
          }
          .versionInfo {
            width: 120px;
            margin-right: 6px;
          }
        }
        .feedbackBlock {
          padding-bottom: 30px;
        }
      }
      .sidemenuClose {
        width: calc(100vw - 582px + 310px);
      }
    }
    .mdMenu {
      transition: height 0.1s ease;
      background: #ffffff;
      width: 220px;
      flex: 0 0 220px;
      overflow-x: unset;
      overflow-y: auto;
      position: sticky;
      max-height: calc(100vh - 184px);
      top: 56px;
      .rightMenu {
        right: 0;
        padding-right:30px;
        padding-left: 16px;
        padding-top: 30px;
        .menuTitle {
          font-size: 16px;
          font-weight: bold;
          font-family: "Roboto Bold", "Microsoft JhengHei";
          color: #787878;
        }
        ul {
          margin-block-start: 13px;
          padding-inline-start: 16px;
          list-style: none;
        }

        .menuItem {
          font-weight: normal;
          cursor: pointer;
          li {
            position: relative;
            padding-bottom: 12px;
            .listItem {
              font-size: 14px;
              font-weight: normal;
              color: #787878;
              text-decoration: none;
              line-height: 18px;
            }
            .listIcon {
              position: absolute;
              top: 6px;
              left: -14px;
              width: 0;
              height: 100%;
              border-left: 2px solid #c8c8c8;
            }
            .listIcon:before {
              content: "";
              position: absolute;
              top: 0;
              left: 0;
              width: 6px;
              height: 6px;
              border: none;
              border-radius: 50%;
              background: #c8c8c8;
              top: -2px;
              left: -4px;
            }
          }
          li.activeItem {
            .listItem {
              font-weight: bold;
              font-family: "Roboto Bold", "Microsoft JhengHei";
              color: #008cd6;
            }
            .listIcon:before {
              background: #008cd6;
            }
          }
          li:last-child {
            .listIcon {
              border-left: 2px solid #fff;
            }
          }
          li:hover {
            .listItem {
              color: #004280;
            }
            .listIcon:before {
              background: #004280;
            }
          }
          li:active {
            .listItem {
              font-weight: bold;
              font-family: "Roboto Bold", "Microsoft JhengHei";
              color: #008cd6;
            }
            .listIcon:before {
              background: #008cd6;
            }
          }
        }
      }
    }
  }
  .apiContainer {
    .mdfile {
      .mdfilebox, .sidemenuClose {
        width: 100%;
      }
    }
    .mdMenu {
      display: none;
    }
  }
  .videoContainer{
    .mdfile {
      .mdfilebox, .sidemenuClose {
        width: 100%;
        padding-right: 100px;
        .videoFrame {
          margin:8px 0 30px;
          .el-tab-pane{
            position: relative;
            padding-bottom: 52.8%;
            overflow: hidden;
            iframe, object{
              position: absolute;
              top: 0;
              left: 0;
              width:100%;
              height: 100%;
            }
          }
        }
        .videoRef {
          padding-top: 16px;
          padding-bottom: 16px;
          border-top: solid 1px #c8c8c8;
          ul {
            padding-left: 30px;
            li {
              list-style-image: url("../../assets/icon/img_dot.svg");
              line-height: 24px;
              color: #787878;
              a {
                cursor: default;
              }
              p {
                vertical-align: top;
                display: inline-block;
                margin-top: -3px;
                margin-left: -6px;
                line-height: 24px;
                color: #787878;
              }
              .tp-link{
                cursor: pointer;
                &:hover{
                  color: #008cd6;
                  text-decoration: underline;
                }
                &:active{
                  color: #004280;;
                  text-decoration: underline;
                }
              }
            }
          }
        }
      }
    }
    .mdMenu {
      display: none;
    }
  }
  .pdfContainer {
    .mdfile {
      .mdfilebox, .sidemenuClose {
        width: 100%;
      }
      .pdf-load-more {
        border-top: 1px solid #e6e6e6;
        background-color:#fafafa;
        height: 48px;
        display: flex;
        justify-content: center;
        span {
          line-height: 48px;
          color: #008cd6;
          text-decoration: underline;
        }
        &:hover {
          cursor: pointer;
          background-color:#f5fbfe;
        }
        &:active {
          span {
            color: #004280;
          }
        }
      }
    }
    .mdMenu {
      display: none;
    }
  }
}
@media (max-width: 1035px) {
  .guidesDocContent {
    .container {
      .mdfile {
        .mdfilebox {
          width: calc(100vw - 562px);
        }
        .sidemenuClose {
          width: calc(100vw - 562px + 290px);
        }
      }
    }
    .apiContainer,.videoContainer, .pdfContainer {
      .mdfile {
        .mdfilebox, .sidemenuClose {
          width:100%;
        }
      }
      .mdMenu {
        display: none;
      }
    }
  }
}

@media (max-width: 950px) {
  .guidesDocContent {
    .container {
      .mdfile {
        .mdfilebox {
          width: calc(100vw - 342px);
          padding-right: 14px;
        }
        .sidemenuClose {
          width: calc(100vw - 342px + 290px);
        }
      }
      .mdMenu {
        display: none;
      }
    }
  }
}
@media (max-width: 635px) {
  .guidesDocContent {
    .container {
      .mdfile {
        .mdfilebox {
          width: 100%;
          padding-left: 20px;
        }
      }
    }
    .apiContainer {
      .mdfile {
        .mdfilebox, .sidemenuClose {
          width: calc(100vw - 10px);
        }
      }
    }
  }
}
@media (max-width: 320px) {
  .guidesDocContent {
    .container {
      .mdfile {
        .mdfilebox {
          width: 100%;
          padding-left: 20px;
          .mdfileTitle {
            line-height: 32px;
            font-size: 22px;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
  .el-select-dropdown {
    width: 91px !important;
  }

  .icon-warning {
    display: inline-block;
    vertical-align: middle;
    width: 32px;
    height: 32px;
    line-height: 32px;
    background-size: 32px;
    background-image: url("../../assets/icon/btn_main_warning_normal.svg");
  }
  .warning-enter-active {
    animation: bounce-in .2s;
  }
  .warning-leave-active {
    animation: bounce-out .2s;
  }
  @keyframes bounce-in {
    from {
      top: 10px;
      opacity: 0;
    }
    to {
      top: 0;
      opacity: 1;
    }
  }
  @keyframes bounce-out {
    from {
      top: 0;
      opacity: 1;
    }
    to {
      top: 10px;
      opacity: 0.5;
    }
  }
</style>
